import MarqueeCarousel from "@/components/organisms/Carousels/MarqueeCarousel";
import React from "react";

type Props = {
  list: Array<string>;
  isFeatured?: boolean;
};

const MarqueeImages: React.FC<Props> = ({ list, isFeatured = false }) => {
  return (
    <MarqueeCarousel speedMultipler={5}>
      {list.map((item, index) => (
        <div className="mx-6 h-20 w-40" key={index}>
          <img
            key={index}
            src={item}
            alt="featured creator"
            className="h-full"
          />
        </div>
      ))}
    </MarqueeCarousel>
  );
};

export default MarqueeImages;
